import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`font-mono text-xs uppercase tracking-[0.3em] text-amber2 ${className}`}
  >
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <Eyebrow className={align === "center" ? "text-center" : ""}>{eyebrow}</Eyebrow>
    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-slate-50 leading-[0.95]">
      {title}
    </h2>
    {sub && (
      <p className="mt-4 max-w-2xl text-base text-slate-400 leading-relaxed">{sub}</p>
    )}
  </Reveal>
);
